import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import '../styles/ReviewItem.css';
import ReviewAction from './ReviewAction';

const ReviewItem = () => {
  const { id } = useParams(); // URL에서 '5' 같은 호수 번호를 가져옴
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      setLoading(true);
      try {
        // 1. 문서 ID 규칙에 맞춰 가져오기 (예: review_5)
        const docRef = doc(db, 'reviews', `review_${id}`);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // 2. 파이어베이스의 'reviews' 배열 데이터를 상태에 저장
          setReviews(docSnap.data().reviews || []);
        } else {
          setReviews([]);
        }
      } catch (error) {
        console.error('후기 로딩 실패:', error);
      }
      setLoading(false);
    };

    fetchReviews();
  }, [id]);

  if (loading) return <div className="loading">후기를 불러오는 중...</div>;

  return (
    <div className="issue-content-area review-list-container">
      <h2 className="display-title-review">독자 후기 게시판</h2>
      {reviews.length > 0 ? (
        reviews.map((item, index) => (
          <div key={index} className="review-card">
            <div className="review-body-text">{item.body}</div>
            <div className="review-tag">독자</div>
            {/* <div className="review-to"> {item.target || '작가님'}</div> */}

            {/* 파이어베이스의 'body' 필드 출력 */}

            {/* <footer className="review-info">
              {item.date || '2026. 01. 29.'} &nbsp; {item.nickname || '익명'} 님
            </footer> */}
          </div>
        ))
      ) : (
        <div className="empty-review-box">
          <p>아직 등록된 후기가 없습니다 </p>
        </div>
      )}
      <ReviewAction />
    </div>
  );
};

export default ReviewItem;
